<template>
  <section>
    <!-- Profile & Stats -->
    <PlayerStats :username="username" />

    <div v-if="username" class="mt-6">
      <RatingChart :username="username" course="en_glicko2" />
    </div>

    <div v-if="username" class="mt-6">
      <MatchesTableFiltered :username="username" />
    </div>

    <TabTitle :title="username ? username : 'loading...'" />
  </section>
</template>

<script>
import PlayerStats from "@/components/stats/PlayerStats.vue";
import TabTitle from "../components/TabTitle.vue";
import RatingChart from "../components/stats/RatingChart.vue";
import MatchesTableFiltered from "../components/tables/MatchesTableFiltered.vue";
import { mapGetters } from "vuex";

export default {
  name: "Profile",

  components: {
    PlayerStats,
    TabTitle,
    RatingChart,
    MatchesTableFiltered,
  },

  data() {
    return {
      username: null,
    };
  },

  computed: {
    ...mapGetters(["getPlayer"]),
  },

  watch: {
    getPlayer: {
      immediate: true,
      handler() {
        if (this.$route.query.u) return;
        if (!this.getPlayer) return;
        this.username = this.getPlayer.username;
      },
    },
  },

  created() {
    if (this.$route.query.u) {
      this.username = this.$route.query.u;
    }
  },
};
</script>

<style scoped></style>
